import IconCircle from './IconCircle';
import { FaExclamationCircle } from './icons';
import Button from './Button';

interface Props {
  title?: string;
  body?: string;
  onRetry?: () => void;
}

export default function ErrorPanel({
  title = 'Failed to load',
  body = 'Try refreshing the page.',
  onRetry,
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-8 text-center">
      <IconCircle icon={<FaExclamationCircle />} tone="danger" size="lg" />
      <h4 className="mt-4 text-base font-semibold text-danger">{title}</h4>
      <p className="mt-1 max-w-sm text-sm text-bodydark2">{body}</p>
      {onRetry && (
        <div className="mt-3">
          <Button variant="ghost" size="sm" onClick={onRetry}>Try again</Button>
        </div>
      )}
    </div>
  );
}
